module.exports = {
      id: "13677837f8b22d9f7a25cbbc8c25449akitchenEquipment-combined-stove.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.svg#13677837f8b22d9f7a25cbbc8c25449akitchenEquipment-combined-stove.svg",
      toString: function () {
        return this.url;
      }
    }